import { Subscription, tap } from 'rxjs';
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UploaderValue } from '../subtitles-uploader/models';
import { SubtitlesControlsModel } from '../../../../models';
import { FileDownloadService } from '@app/core/service/file-download/file-download.service';

@Component({
    selector: 'app-upload-subtitles-item',
    templateUrl: './subtitles-item.component.html',
    styleUrls: ['./subtitles-item.component.scss'],
    providers: [FileDownloadService],
    standalone: false
})
export class UploadSubtitlesItemComponent implements OnInit, OnDestroy {
    @Input() subtitlesControls: FormGroup<SubtitlesControlsModel>;
    @Input() index: number;
    @Output() removeSubtitles: EventEmitter<number> = new EventEmitter();

    private readonly subsriptions$ = new Subscription();

    fileControl = new FormControl<UploaderValue>({
        file: null,
        hash: null,
    });

    constructor(
        private cdr: ChangeDetectorRef,
        private fileDownloadService: FileDownloadService,
    ) {}

    ngOnInit(): void {
        this.subsriptions$.add(
            this.fileControl.valueChanges
                .pipe(
                    tap(() => {
                        this.subtitlesControls.get('filename').patchValue(this.fileName);
                        this.subtitlesControls.get('hash').patchValue(this.hash);
                        this.cdr.detectChanges();
                    }),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.subsriptions$.unsubscribe();
    }

    get newLanguageControl() {
        return this.subtitlesControls.get('newLanguage');
    }

    get subtitlesStatusControl() {
        return this.subtitlesControls.get('status');
    }

    get hasHash() {
        return this.fileControl.value?.hash?.length > 0;
    }

    get hasFile() {
        return this.fileControl.value?.file;
    }

    get downloadSubtitlesUrl() {
        const url = this.subtitlesControls.get('downloadUrl')?.value;
        return url && url + `?response-content-disposition=attachment; filename="${this.fileName}"`;
    }

    get hash() {
        return this.fileControl.value?.hash;
    }

    get fileName() {
        const name = this.hasFile ? this.fileControl.value?.file.name : this.subtitlesControls.get('filename')?.value;
        return name?.length > 0 ? name : null;
    }

    get subtitlesEnabledControl() {
        return this.subtitlesControls.get('enabled');
    }

    remove() {
        this.removeSubtitles.next(this.index);
    }

    downloadSubtitles() {
        const filename = ';filename=' + this.fileName;
        this.fileDownloadService.downloadSubtitles(this.downloadSubtitlesUrl, filename);
    }
}
